import 'slick-carousel';

import 'youtube-video-js';

// import { gsap } from "gsap";
// import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
// gsap.registerPlugin(ScrollTrigger);

import AOS from 'aos';

import 'select2';                 
import 'select2/dist/css/select2.css';
import { indexOf } from 'lodash';

// import 'youtube-video-js';

// var videojs = require('video.js');
// var Youtube = require('../../../../node_modules/videojs-youtube');

export class Plugins{

  init(){

    AOS.init({
      duration: 1000,
      once: true
    });


    $(".hero-section").slick({
      dots: true,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 10000,
      slidesToShow: 1,
    });

    $(".testimonial-customer").slick({
      dots: false,
      speed: 500,
      arrows: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: $(".testimonial-section .slick--prev"),
      nextArrow: $(".testimonial-section .slick--next"),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    
    $(".parallex-section-home").slick({
      dots: true,
      speed: 500,
      fade: true,
      arrows: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    $(".about-parallex-section").slick({
      dots: true,
      speed: 500,
      fade: true,
      arrows: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    $(".parallex-section-trade").slick({
      dots: true,
      speed: 500,
      fade: true,
      arrows: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    $(".instagram").slick({
      dots: false,
      speed: 500,
      arrows: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 1,

      responsive: [
        {
          breakpoint: 1200, // screen width at which the settings will change
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        },
      ]
    });

    $(".product-related").slick({
      dots: false,
      speed: 500,
      arrows: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1
          }
        },
        
      ]
    });

    $(".productpage-slide").slick({
      dots: true,
      speed: 500,
      fade: true,
      arrows: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $(".product-section-1 .slick--prev"),
      nextArrow: $(".product-section-1 .slick--next")
    });

    $(".client-pro-review").slick({
      dots: false,
      speed: 500,
      arrows: true,
      fade: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $(".client-review  .slick--prev"),
      nextArrow: $(".client-review  .slick--next")
    });

    // DOLLY JS START
    $(".content-slider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 500,
      autoplay: true,
      slidesToShow: 1,

      responsive: [
        {
          breakpoint: 768, // screen width at which the settings will change
          settings: {
            dots: true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
          }
        }
      ]
    });

    $(".about-team").slick({
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: $(".about-team-section .slick--prev"),
      nextArrow: $(".about-team-section .slick--next"),
      responsive: [
        {
          breakpoint: 1024, // screen width at which the settings will change
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 525,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

    // $(".js-example-tags").select2({
    //   tags: true
    // });

    // $(document).ready(function() {
    //   $('#mySelect').on('click',function(){
    //     $(this).addClass('select-no-focus');
    //   })
    // })

    $(".js-select2").select2({
      closeOnSelect: true,
      minimumResultsForSearch: Infinity,
      allowClear: false,
      dropdownCssClass: "filter-dropdown"
    });

    this.addToCartQty();
    this.addToCartQty();
    this.videoJS();
  }

  videoJS() {

    // const videoElement = document.querySelector('youtube-video');
    // // must wait for DOM to be ready and for component to be accessible
    // document.addEventListener('DOMContentLoaded', function () {
    //     // wait for loading
    //     videoElement.load().then(() => {
    //         // pause video after two seconds
    //         // const timer = setTimeout(function () {
    //         //     videoElement.pause();
    //         //     clearTimeout(timer);
    //         // }, 2000);
    //     });
    // });

  }

  
  addToCart() {
    $('.add-to-cart-button').on('click',function() {
      e.preventDefault();

      
    });     
  }

  addToCartQty() {
    $(".js-select2").change(function(){
      var currentQtyParent = $(this).parent();

      var currentQtyLocation = $(currentQtyParent).find('.select2-selection__rendered')

      var currentQty = $(currentQtyLocation).attr('title');

      $('.add-to-cart-field').attr("value", currentQty);
    });
  }

  slickSLider() { }


}
